import { render, staticRenderFns } from "./AssetCut.vue?vue&type=template&id=6cca0d27&"
import script from "./AssetCut.vue?vue&type=script&lang=js&"
export * from "./AssetCut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports